import React from "react";
import { Button } from "@/components/ui/button";
import { openWhatsApp } from "@/lib/api";

// Inline WhatsApp glyph (brand-authentic green speech bubble). Kept local so we
// don't add an icon dependency and get the exact green everywhere.
export const WhatsAppIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 01-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 01-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.05 2.264-.02 1.06.504 2.03 1.18 2.836 1.4 1.65 2.912 2.98 4.904 3.75.402.13.804.144 1.204.144.685 0 1.35-.174 1.85-.617.406-.36.555-.867.555-1.375 0-.243-.123-.485-.323-.617-.286-.187-.617-.257-.933-.257z"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M16 0C7.164 0 0 7.164 0 16c0 2.846.744 5.518 2.049 7.83L0 32l8.375-2.021A15.94 15.94 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.36c-2.402 0-4.66-.673-6.586-1.84l-.472-.28-4.98 1.202 1.223-4.858-.31-.502A13.36 13.36 0 012.64 16C2.64 8.62 8.62 2.64 16 2.64S29.36 8.62 29.36 16 23.38 29.36 16 29.36z"/>
  </svg>
);

/**
 * WhatsApp share button. Renders green pill; opens wa.me in new tab.
 * Props: mobile (customer's 10-digit or +91 number), message (pre-filled body),
 * label (optional button text), size, testid.
 */
export default function WhatsAppShareButton({ mobile, message, label = "WhatsApp", size = "sm", variant = "outline", testid }) {
  const disabled = !mobile;
  const cls = variant === "solid"
    ? "bg-[#25D366] hover:bg-[#20BD5A] text-white border-transparent"
    : "border-emerald-300 text-emerald-700 hover:bg-emerald-50";
  return (
    <Button
      type="button"
      size={size}
      variant={variant === "solid" ? "default" : "outline"}
      className={cls}
      disabled={disabled}
      onClick={() => openWhatsApp(mobile, message)}
      data-testid={testid || "whatsapp-share-btn"}
      title={disabled ? "No mobile on record" : `Send via WhatsApp to ${mobile}`}
    >
      <WhatsAppIcon className="w-3.5 h-3.5 mr-1" />
      {label}
    </Button>
  );
}
